<template>
    <div class="mdc-tab-bar button-slider" role="tablist">
        <div class="mdc-tab-scroller">
            <div class="mdc-tab-scroller__scroll-area">
                <div class="mdc-tab-scroller__scroll-content">
                                        <button
                        class="mdc-tab mdc-tab"
                        :class="{ 'mdc-tab--active': !login }"
                        role="tab"
                        aria-selected="true"
                        tabindex="1"
                        @click="gotoRegister"
                    >
                        <span class="mdc-tab__content">
                            <span class="mdc-tab__text-label">
                                <p class="hidden lg:block">
                                    {{ second_title }}
                                </p>
                                <p class="lg:hidden block">
                                    {{ second_title_mobile }}
                                </p>
                                <p
                                    v-if="second_title_mobile2"
                                    class="lg:hidden block"
                                >
                                    {{ second_title_mobile2 }}
                                </p>
                            </span>
                        </span>
                        <span
                            class="mdc-tab-indicator "
                            :class="{ 'mdc-tab-indicator--active': !login }"
                        >
                            <span
                                class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"
                            ></span>
                        </span>
                        <span class="mdc-tab__ripple"></span>
                    </button>
                    <button
                        class="mdc-tab"
                        :class="{ 'mdc-tab--active': login }"
                        role="tab"
                        aria-selected="true"
                        tabindex="0"
                        @click="gotoLogin"
                    >
                        <span class="mdc-tab__content">
                            <span class="mdc-tab__text-label">
                                <p class="hidden lg:block">{{ first_title }}</p>
                                <p class="lg:hidden block">
                                    {{ first_title_mobile }}
                                </p>
                                <p
                                    v-if="first_title_mobile2"
                                    class="lg:hidden block"
                                >
                                    {{ first_title_mobile2 }}
                                </p>
                            </span>
                        </span>
                        <span
                            class="mdc-tab-indicator"
                            :class="{ 'mdc-tab-indicator--active': login }"
                        >
                            <span
                                class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"
                            ></span>
                        </span>
                        <span class="mdc-tab__ripple"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { MDCTabBar } from "@material/tab-bar";

export default {
    props: [
        "first_title",
        "second_title",
        "first_title_mobile",
        "second_title_mobile",
        "first_title_mobile2",
        "second_title_mobile2"
    ],
    data() {
        return {
            login: true
        };
    },
    mounted() {
        const tabBar = new MDCTabBar(document.querySelector(".mdc-tab-bar"));
        var path = window.location.pathname;
        var n = path.split("/");

        if (n[n.length - 1] == "login") {
            this.login = true;
        } else {
            this.login = false;
        }
    },
    methods: {
        gotoRegister() {
            window.location.href = "register";
        },
        gotoLogin() {
            window.location.href = "login";
        }
    }
};
</script>
<style lang="scss" scoped>
.button-slider {
    padding: 0 1rem;
    p{
        color: #9a9c96;
        margin: 1rem;
    }
    .mdc-tab {
        height: 80px;
        &__text-label{
            text-transform: initial !important;
        }
        @media (min-width:1024px) {
            height: unset;
        }
    }
    .mdc-tab--active{
        p{
            color: black;
        }
    }
    button {
        width: 50%;
        margin: 0;
        padding: 0 1rem;
        &:hover {
            background-color: rgba($color: #000000, $alpha: 0.1);
        }
    }

    .mdc-tab-indicator .mdc-tab-indicator__content--underline {
        border-top-width: 2px;
    }
}

</style>
